import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
export interface InstitutionSearchFormValue {
  institutionId: string;
  institutionName: string;
  dunsNumber: string;
  uniqueEntityId: string;
  supplierId: string;
  riskCategory: string;
  country: string;
  samGov: string;
  foreignEntity: string;
  deleted: string;
}

@Injectable({
  providedIn: 'root',
})
export class InstitutionSearchService {
  private readonly searchFormValue =
    new BehaviorSubject<InstitutionSearchFormValue | null>(null);

  select(formValue: InstitutionSearchFormValue): void {
    this.searchFormValue.next({ ...formValue });
  }

  getSearchForm(): Observable<InstitutionSearchFormValue | null> {
    return this.searchFormValue.asObservable();
  }
}
